export var MailchimpFragment = "\n  fragment MailchimpFragment on Mailchimp {\n    name\n    embedCode\n    jotFormLink\n  }\n";